import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '众志成城，守望相助，坚决打赢疫情歼灭战';
const baseUrl = 'yqfk20221115';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/fkbs`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'fkbs',
      name: `${baseUrl}-fkbs`,
      component: () => import('./pages/Fkbs.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'fkbsmore',
      name: `${baseUrl}-fkbsmore`,
      component: () => import('./pages/more/Fkbs.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'fbmore',
      name: `${baseUrl}-fbmore`,
      component: () => import('./pages/more/Public.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'swxzmore',
      name: `${baseUrl}-swxzmore`,
      component: () => import('./pages/more/Swxz.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'dygbzxdmore',
      name: `${baseUrl}-dygbzxdmore`,
      component: () => import('./pages/more/Dygbzxd.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'bzzhymmore',
      name: `${baseUrl}-bzzhymmore`,
      component: () => import('./pages/more/Bzzhym.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'whdcysxmore',
      name: `${baseUrl}-whdcysxmore`,
      component: () => import('./pages/more/Whdcysx.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'hygqmore',
      name: `${baseUrl}-hygqmore`,
      component: () => import('./pages/more/Hygq.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
